<script lang="ts">
import { defineComponent } from 'vue';
import router from '../../router';
import RadioButton from '../../components/RadioButton.vue';
import SolutoButton from '../../components/SolutoButton.vue';
import { mapActions, mapGetters } from 'vuex';

// this is Q12 in e-confluence page for call survey
export default defineComponent({
  name: 'SurveyQ6',
  components: {
    RadioButton,
    Button: SolutoButton
  },
  data () {
    return {
      data: [
        { text: this.$t('level7'), key: '7' },
        { text: '6', key: '6' },
        { text: '5', key: '5' },
        { text: '4', key: '4' },
        { text: '3', key: '3' },
        { text: '2', key: '2' },
        { text: this.$t('level1'), key: '1' }
      ]
    };
  },
  computed: {
    ...mapGetters([
      'supportHelpfulnessScale',
      'isCallSurvey'
    ])
  },
  methods: {
    ...mapActions([
      'changeSupportHelpfulnessScale'
    ]),
    change (event: number) {
      this.changeSupportHelpfulnessScale(event);
    },
    nextScreen () {
      if (this.supportHelpfulnessScale === '7') {
        router.push({ path: '/survey/question8/' });
      } else {
        router.push({ path: '/survey/question71/' });
      }
    },
    goBack () {
      router.go(-1);
    }
  }
});
</script>

<template>
  <div class="mainSurvey">
    <div class="q1">
      <p class="with-margin">{{ isCallSurvey ? $t('survey_06_01_call') : $t('survey_06_01') }}</p>
      <p class="with-margin">{{ isCallSurvey ? $t('survey_06_02_call') : $t('survey_06_02') }}</p>
      <radio-button :text="data" @change="change($event)" :value="supportHelpfulnessScale.toString()"/>
    </div>
    <div class="mainSurvey-footer">
      <Button
        class="footer-button"
        :size="'large'"
        :text="$t('previous')"
        :type="'outlined'"
        @click="goBack()"
      />
      <Button
        class="footer-button"
        :disabled="!supportHelpfulnessScale"
        :size="'large'"
        :text="$t('next')"
        @click="nextScreen()"
      />
    </div>
  </div>
</template>
